import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import AdvertCard from 'desktop/components/AdvertCard/AdvertCard';
import Carousel from 'desktop/components/Carousel/Carousel';
import s from './DealerAdvertsAds.css';

const IMAGE_WIDTH = 172;

class DealerAdvertsAds extends React.Component {
  static propTypes = {
    cars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    //
    intl: intlShape.isRequired,
  };

  render() {
    const { intl, cars } = this.props;
    if (!(cars && cars.length)) {
      return null;
    }
    const imageStyles = { height: '125px' };

    return (
      <div className={s.root}>
        <div className={s.container}>
          <Carousel
            step={4}
            itemsInRow={4}
            loop
            classNames={{
              header: s.header,
              body: s.carouselBody,
            }}
            header={
              <div className={s.title}>
                {intl.formatMessage({ id: 'Предложения автосалонов' })}
              </div>
            }
            items={cars.map(car =>
              <AdvertCard
                key={car.id}
                item={car}
                imageStyle={imageStyles}
                advertClassName={s.advertItem}
                cardType="dealerads"
                width={IMAGE_WIDTH}
              />,
            )}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(DealerAdvertsAds));



// WEBPACK FOOTER //
// ./src/desktop/components/DealerAdvertsAds/DealerAdvertsAds.js